import React from 'react';
import './promotionChat.css';

const PromotionChatSection: React.FC = () => {
  
  // Datos de testimonios
  const testimonials = [
    {
      id: 1,
      text: "Pedí un plomero en 30 segundos. Increíblemente fácil.",
      author: "María G.",
      position: "left",
      avatar: "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2FUser%20Avatar%203.png?alt=media&token=61cbd941-b01d-4454-9bbc-f75d6eef1cfe"
    },
    {
      id: 2,
      text: "El electricista llegó en menos de 2 horas. ¡Servicio excelente!",
      author: "Carlos M.",
      position: "right",
      avatar: "https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2FEllipse%202.png?alt=media&token=248c653c-58e5-4ed3-a6c5-9e69b1256061"
    }
  ];

  return (
    <div className="py-2 md:py-16">
      <div className="container mx-auto px-4 md:px-12">
        <div className="mb-12">
          <h2 className="text-center text-3xl md:text-4xl font-bold text-gray-800 dark:text-white mb-2">
            Solicita servicios con inteligencia 
          </h2>
          <p className="text-left text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Con XERVIX, pedir un servicio es tan fácil como enviar un mensaje. Nuestra inteligencia artificial entiende tus necesidades, te guía paso a paso y conecta en segundos con profesionales confiables. Sin formularios largos. Sin llamadas. Sin estrés.
            Solo escribe lo que necesitas, ¡y deja que la magia ocurra!
          </p>
        </div>

        <div className="relative z-10 flex justify-center items-center mt-8 mb-16">
        

          {/* Testimonio flotante izquierdo */}
          <div className="absolute left-0 md:left-10 lg:left-0 top-[25%] z-20 transform -translate-y-1/2 animate-float-slow hidden md:block">
            <div className="bg-xervix-primary rounded-lg shadow-lg p-4 max-w-xs">
              <div className="flex items-start">
                <div className="flex-shrink-0 mr-3">
                  <img src={testimonials[0].avatar} alt={testimonials[0].author} className="w-10 h-10 rounded-full object-cover" />
                </div>
                <div>
                  <p className="text-white text-sm">"{testimonials[0].text}"</p>
                  <p className="text-white font-medium text-sm mt-1">— {testimonials[0].author}</p>
                </div>
              </div>
              <div className="absolute -bottom-2 left-6 w-4 h-4 bg-xervix-primary transform rotate-45"></div>
            </div>
          </div>       
       
          
          <img 
            src="https://firebasestorage.googleapis.com/v0/b/xervix-ia.firebasestorage.app/o/landing%2Flaptop%20(1).png?alt=media&token=846c1680-e8cd-4a0b-8109-abb5e7e66ec5"
            alt="Servicios Xervix" 
            className="w-[80%] h-auto object-contain mx-auto"
          />        

          {/* Testimonio flotante derecho */}
          <div className="absolute right-0 md:right-10 lg:right-24 bottom-[35%] z-20 transform translate-y-1/2 animate-float hidden md:block">
            <div className="bg-xervix-primary rounded-lg shadow-lg p-4 max-w-xs">
              <div className="flex items-start">
                <div className="flex-shrink-0 mr-3">
                  <img src={testimonials[1].avatar} alt={testimonials[1].author} className="w-10 h-10 rounded-full object-cover" />
                </div>
                <div>
                  <p className="text-white text-sm">"{testimonials[1].text}"</p>
                  <p className="text-white font-medium text-sm mt-1">— {testimonials[1].author}</p>
                </div>
              </div>
              <div className="absolute -bottom-2 right-6 w-4 h-4 bg-xervix-primary transform rotate-45"></div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default PromotionChatSection;
